import { carsSaga } from './cars';
import { optionsSaga } from './options';
import { errorSaga } from './error';

export default [carsSaga, optionsSaga, errorSaga];
